// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3zene","field":"styles_field__13HnD","fieldCol":"styles_fieldCol__4V7Jb","diffCol":"styles_diffCol__37tkd","diff":"styles_diff__2WdAN"};